module.exports = __webpack_public_path__ + "img/sb02.47947589.png";